/** Indica se há anexo de arquivo no composer (prop `file` e/ou lista `files`). */
export function hasComposerFileAttachment(file, files) {
  if (file != null && file !== false) return true;
  return Array.isArray(files) && files.length > 0;
}

/**
 * Payload suficiente para exibir/enviar (texto, anexo(s) ou áudio gravado).
 * Usado no botão Enviar / alternância com microfone.
 */
export function composerHasSendPayload(message, file, files, audioURL) {
  const text = typeof message === "string" ? message.trim() : "";
  return Boolean(text) || hasComposerFileAttachment(file, files) || Boolean(audioURL);
}
